import { BreadcrumbsProps, Breadcrumbs as MuiBreadcrumbs } from "@mui/material";

type Props = BreadcrumbsProps;

export const Breadcrumbs = ({ children, ...props }: Props) => {
  return <MuiBreadcrumbs {...props}>{children}</MuiBreadcrumbs>;
};
